export default __webpack_public_path__ + "static/media/folded-clothes.740dbdf1.svg";